import Vue from 'vue';
import Vuex from 'vuex';

import app from 'store/app';
import forms from 'store/forms';
import meta from 'store/meta';
import modals from 'store/modals';
import auth from 'store/auth';
import review from 'store/review';
import payment from 'store/payment';
import header from 'store/header';
import dashboard from 'store/dashboard';
import reviewer from 'store/reviewer';
import emails from 'store/emails';

Vue.use(Vuex);

const store = new Vuex.Store({ // eslint-disable-line import/no-named-as-default-member
  modules: {
    app,
    forms,
    meta,
    modals,
    auth,
    review,
    payment,
    header,
    dashboard,
    reviewer,
    emails,
  },
});

export default store;



// WEBPACK FOOTER //
// ./client/store/index.js